import { render, staticRenderFns } from "./SubpageListBlock.vue?vue&type=template&id=956e5778"
import script from "./SubpageListBlock.vue?vue&type=script&lang=js"
export * from "./SubpageListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports